const { REACT_APP_BASE_URL: BASE_API_URL } = process.env;

// to connect sms channel
export const CONNECT_SMS_CHANNEL = `${BASE_API_URL}/sms/sub_organizations/:subOrgId/sign_up_for_sms_plan`;

// to send sms
export const SEND_SMS_REPLY = `${BASE_API_URL}/leads/send_sms`;
